import { forwardRef, useState, type InputHTMLAttributes } from "react";

import { cx } from "./cx";
import { Icon } from "./Icon";
import { CONTROL } from "./Input";

type PasswordInputProps = Omit<InputHTMLAttributes<HTMLInputElement>, "type"> & {
  /** Base input classes; defaults to the shared Input look. */
  control?: string;
};

/** A password Input with an eye button that shows or hides what was typed. */
export const PasswordInput = forwardRef<HTMLInputElement, PasswordInputProps>(function PasswordInput(
  { control = CONTROL, className, ...rest },
  ref,
) {
  const [visible, setVisible] = useState(false);
  return (
    <div className="relative">
      <input
        ref={ref}
        type={visible ? "text" : "password"}
        className={cx(control, "pr-11", className)}
        {...rest}
      />
      {/* A disabled field has nothing to show or hide (QB-057: no unexplained disabled toggle). */}
      {!rest.disabled && (
        <button
          type="button"
          onClick={() => setVisible((shown) => !shown)}
          aria-label={visible ? "Hide password" : "Show password"}
          aria-pressed={visible}
          className="absolute top-1/2 right-1.5 grid size-8 -translate-y-1/2 cursor-pointer place-items-center rounded-md text-fg-subtle transition-colors hover:text-fg focus-visible:outline-2 focus-visible:outline-brand-500 aria-pressed:text-fg"
        >
          <Icon name={visible ? "eye-off" : "eye"} size={16} />
        </button>
      )}
    </div>
  );
});
